module.exports = __webpack_public_path__ + "static/sock-prototype-da894e21289c69c5d14a1ec5ca26c9e4.jpg";